import { createStore, createHook } from 'react-sweet-state';
import AX from 'axios';
import Downloader from 'js-file-download';
import moment from 'moment';
import { sortBy } from 'lodash';
import axios from '../../../_actions/axiosInstance';
import { getDeficiencies, getChart } from '../../../_actions';
import {
  processLineChartDataV2,
  mySitesAvailable,
  getCurrectWeekRange
} from '../../../helpers/utils';
// import { calendar as calendarData } from '../../../helpers/demo_data';
// import jsonData from '../widget2.json';
import config from '../../../_config/config';
import history from '../../../helpers/history';

const getPercent = (monthBefore, lastMonth) => {
  let result = 0;
  if (monthBefore === 0 && lastMonth === 0) {
    return 0;
  }
  if (monthBefore > lastMonth) {
    result = Math.round(((monthBefore - lastMonth) / monthBefore) * -100).toString();
  } else {
    result = `+${Math.round(((lastMonth - monthBefore) / lastMonth) * 100)}`;
  }
  return result;
};

export const WEEK = 'Week';
export const DAY = 'Day';
export const MONTH = 'Month';

export const ALARMS = 'ATG Alarms';
export const TRENDS = 'Trends';
export const COMPLIANCE = 'Compliance';
export const CALENDAR = 'Calendar';
let draftClient = null;
let tokenRef = AX.CancelToken.source();
const DashboardStore = createStore({
  // value of the store on initialisation
  initialState: {
    clientView: !mySitesAvailable(),
    exceptionsPercent: null,
    exceptionsNow: null,
    infoModal: false,
    selectedClient: null,

    siteReports: {
      user: {},
      client: {}
    },

    alarmsIssues: {
      user: {},
      client: {}
    },

    loadingDefiencies: false,
    defienciesCancelToken: null,

    chartsCancelToken: null,
    charts: '',

    dashboardConfing: [],

    loadingCalendar: false,
    calendar: [],
    calendarTabs: [
      {
        name: 'All',
        active: true,
        filter: ['tests', 'permits', 'route_plans', 'inspections', 'completed_inspections_with_rp']
      },
      {
        name: 'Tests',
        active: false,
        filter: ['tests']
      },
      {
        name: 'Permits',
        active: false,
        filter: ['permits']
      },
      {
        name: 'Inspections',
        active: false,
        filter: ['route_plans', 'inspections', 'completed_inspections_with_rp']
      }
    ],
    calendarModal: false,
    calendarModalData: {},
    calendarType: WEEK,
    calendarTypeOpts: [DAY, WEEK, MONTH],
    calendarDateRange: null,
    calendarSite: null,
    WOView: 'Default view',
    loadingInspections: false,
    loadingAlarmsIssues: false
  },
  // actions that trigger store mutation
  actions: {
    // Main Files Actions
    toggleView: isClient => async ({ setState, getState }) => {
      if (typeof isClient === 'boolean') {
        setState({ clientView: isClient });
        return;
      }
      const { clientView } = getState();
      setState({ clientView: !clientView });
    },
    toggleWOView: view => async ({ setState }) => {
      // if (typeof isManager === 'boolean') {
      //   setState({ WOView: isManager });
      //   return;
      // }
      // const { WOView } = getState();
      setState({ WOView: view });
    },
    toggleInfoModal: () => async ({ setState, getState }) => {
      const { infoModal } = getState();
      setState({ infoModal: !infoModal });
    },
    getChartType: view => async ({ setState, getState }) => {
      setState({ loadingDefiencies: true });
      const { defienciesCancelToken, selectedClient } = getState();
      if (defienciesCancelToken) {
        defienciesCancelToken.cancel();
      }
      const src = AX.CancelToken.source();
      setState({ defienciesCancelToken: src });
      const time = sec => new Promise(resolve => setTimeout(resolve, sec));
      time(20000).then(() => {
        const { exceptionsLastMonth, exceptionsPercent } = getState();
        if (typeof exceptionsLastMonth !== 'number' && typeof exceptionsPercent !== 'number') {
          setState({ loadingDefiencies: false });
        }
      });
      getDeficiencies(src, view, selectedClient?.id)
        .then(res => {
          // eslint-disable-next-line
          const { previous_month, current_month } = res;
          setState({
            exceptionsLastMonth: current_month,
            exceptionsPercent: getPercent(previous_month, current_month),
            loadingDefiencies: false
          });
        })
        .catch(() => {
          // console.error(e);
          setState({
            exceptionsLastMonth: null,
            exceptionsPercent: null,
            loadingDefiencies: false
          });
        });
    },
    emptyChart: () => ({ setState }) => {
      const today = moment();
      const fakeData = {
        data: [{}, {}, {}],
        // labels: ['2022-10', '2022-11', '2022-12', '2023-01', '2023-02'],
        labels: [
          today.subtract(1, 'months').format('YYYY-MM'),
          today.subtract(2, 'months').format('YYYY-MM'),
          today.subtract(3, 'months').format('YYYY-MM'),
          today.subtract(4, 'months').format('YYYY-MM'),
          today.subtract(5, 'months').format('YYYY-MM')
        ],
        totalCounts: {
          recurring: '--',
          repeating: '--',
          total: '--'
        }
      };
      setState({ charts: fakeData });
    },
    getChartsData: () => async ({ setState, getState }) => {
      const { chartsCancelToken, clientView, selectedClient } = getState();
      // const { clientView } = getState();
      // We set 'charts:null' to avoid data confusion. There may be a situation that the request
      // is being processed for a long time and after hiding the spinner, we will see data from the previous request.
      setState({ charts: null });

      // cancel previous request (There may be a situation when the response to the previous request comes late and overwrites the actual data)
      if (chartsCancelToken) {
        chartsCancelToken.cancel();
      }
      let viewType = 'client';
      if (!clientView) {
        viewType = 'user';
      }
      const src = AX.CancelToken.source();
      setState({ chartsCancelToken: src });
      let chartsData;
      try {
        chartsData = await getChart(src, viewType, selectedClient?.id);
      } catch {
        chartsData = null;
      }

      if (chartsData) {
        setState({ charts: processLineChartDataV2(chartsData) });
      }
    },
    getCalendarData: (dateRange, qdata = null, widget = false, clickObj) => async ({
      setState,
      getState
    }) => {
      const { loadingCalendar, clientView, calendarSite, selectedClient } = getState();
      const sameClient = selectedClient?.id === draftClient;
      if (loadingCalendar && sameClient) return;
      draftClient = selectedClient?.id;

      if (widget && !selectedClient?.id) {
        setState({ calendarDateRange: getCurrectWeekRange(1), calendar: [] });
        return;
      }
      setState({ loadingCalendar: true });
      if (tokenRef?.token) {
        tokenRef.cancel('reload');
        tokenRef = AX.CancelToken.source();
      }
      let newDateRange = dateRange;
      // debugger
      if (widget) {
        newDateRange = getCurrectWeekRange(1);
      } else if (!dateRange && !widget) {
        newDateRange = getCurrectWeekRange(0);
      }
      if (qdata?.get('type')) {
        const type = qdata.get('type');

        if (type === DAY) {
          const date = moment(qdata.get(type), 'YYYY/MM/DD');
          newDateRange = `${date.format('YYYY-MM-DD')} - ${date
            .add(1, 'days')
            .format('YYYY-MM-DD')}`;
        }
        if (type === MONTH) newDateRange = qdata.get(type);
        if (type === WEEK) newDateRange = qdata.get(type);
        setState({ calendarType: type, calendarDateRange: newDateRange });
      }
      history.replace({
        search: ''
      });

      axios
        .get(
          config.api.charts.calendar(
            clientView ? 'client' : 'user',
            newDateRange,
            calendarSite,
            selectedClient?.id
          ),
          {
            cancelToken: tokenRef.token
          }
        )
        .then(res => {
          const calendar = res.data;
          // const calendar = calendarData.data;
          setState({ loadingCalendar: false, calendar, calendarDateRange: newDateRange });
          if (clickObj?.current) {
            clickObj.current.click();
          }
        })
        .catch(() => {
          setState({ loadingCalendar: false });
          // eslint-diable-next-line
        });
    },
    toggleCalendarModal: data => async ({ setState, getState }) => {
      const { calendarModal: oldModal } = getState();
      if (oldModal) {
        setState({ calendarModal: !oldModal, calendarModalData: {} });
        return;
      }
      setState({ calendarModal: !oldModal, calendarModalData: data });
    },
    clearCalendar: () => async ({ setState }) => {
      setState({
        calendar: [],
        calendarModal: false,
        calendarType: WEEK,
        calendarModalData: {},
        calendarDateRange: null
      });
    },
    downloadExportCalendar: (startDay, endDay) => async ({ setState, getState }) => {
      setState({ loadingCalendar: true });
      const { clientView, selectedClient } = getState();
      try {
        const api = Number.isInteger(startDay)
          ? config.api.charts.calendar_day_export(startDay, endDay, clientView ? 'client' : 'user')
          : config.api.charts.calendar_export(clientView ? 'client' : 'user', selectedClient?.id);
        const res = await axios.get(api, { responseType: 'arraybuffer' });
        const filename = res.headers['content-disposition'].split('filename=').slice(-1)[0];
        const cType = res.headers['content-type'];
        Downloader(res.data, filename, cType);
      } catch (e) {
        // eslint-disable-next-line
        console.error(e);
      } finally {
        setState({ loadingCalendar: false });
      }
    },
    calendarSetSite: site => ({ setState }) => {
      setState({ calendarSite: site });
    },
    changeCalendarTabs: name => ({ setState, getState }) => {
      const tabs = getState().calendarTabs;
      setState({ calendarTabs: tabs.map(t => ({ ...t, active: t.name === name })) });
    },
    changeCalendarType: type => ({ setState, getState }) => {
      const { calendarDateRange } = getState();
      let dateRange = '';
      if (type === DAY) {
        dateRange = `${calendarDateRange.split(' - ')[0]} - ${calendarDateRange.split(' - ')[0]}`;
      }
      if (type === MONTH) {
        const date = moment(calendarDateRange.split(' - ')[0], 'YYYY/MM/DD');
        dateRange = `${date.startOf('month').format('YYYY-MM-DD')} - ${date
          .endOf('month')
          .add(1, 'day')
          .format('YYYY-MM-DD')}`;
      }
      if (type === WEEK) {
        const date = moment(calendarDateRange.split(' - ')[0], 'YYYY/MM/DD');
        dateRange = `${date.startOf('week').format('YYYY-MM-DD')} - ${date
          .endOf('week')
          .add(1, 'day')
          .format('YYYY-MM-DD')}`;
      }
      setState({ calendarType: type, calendarDateRange: dateRange, calendar: {} });
    },
    changeCalendarRange: range => ({ setState }) => {
      setState({ calendarDateRange: range });
    },
    getIssuesOrAlarms: () => async ({ setState, getState }) => {
      const { clientView, selectedClient, alarmsIssues } = getState();
      if (!selectedClient) {
        setState({ alarmsIssues: { user: {}, client: {} } });
        return;
      }
      setState({ loadingAlarmsIssues: true });
      try {
        const res = await axios.get(
          config.api.api_url +
            config.api.charts.alarmsIssues(clientView ? 'client' : 'user', selectedClient?.id)
        );
        const { data } = res.data;
        const obj = {
          ...alarmsIssues
        };
        const resp = { ...data };
        if (resp.type_of_data === 'issues') {
          resp.type_of_data = 'priority 1s';
        }
        obj[data.view_type] = resp;
        setState({ alarmsIssues: obj, loadingAlarmsIssues: false });
      } catch {
        setState({ loadingAlarmsIssues: false });
      }
    },
    getCompletedInspections: () => async ({ getState, setState }) => {
      const { clientView, siteReports, selectedClient } = getState();
      setState({ loadingInspections: true });
      try {
        const res = await axios.get(
          config.api.api_url +
            config.api.charts.inspectionStats(clientView ? 'client' : 'user', selectedClient?.id)
        );
        const { data } = res.data;
        const obj = {
          ...siteReports
        };
        obj[data.view_type] = data;
        setState({ siteReports: obj, loadingInspections: false });
      } catch {
        setState({ loadingInspections: false });
      }
    },
    setDashboardConfiguration: () => ({ setState }) => {
      const result = [
        {
          widget: ALARMS,
          widget_order: 3
        },
        {
          widget: TRENDS,
          widget_order: 2
        },
        {
          widget: COMPLIANCE,
          widget_order: 1
        },
        {
          widget: CALENDAR,
          widget_order: 4
        }
      ];
      setState({ dashboardConfing: result });
    },
    clearConfig: () => ({ setState }) => setState({ dashboardConfing: null }),
    resolveConfig: clientConfig => ({ setState }) => {
      let result = [
        {
          widget: ALARMS,
          widget_order: 4
        },
        {
          widget: TRENDS,
          widget_order: 2
        },
        {
          widget: COMPLIANCE,
          widget_order: 1
        },
        {
          widget: CALENDAR,
          widget_order: 3
        }
      ];
      if (clientConfig) {
        result = sortBy(clientConfig, ['widget_order']);
      } else {
        result = sortBy(result, ['widget_order']);
      }
      setState({ dashboardConfing: result });
    },
    setClient: selectedClient => ({ setState }) => {
      setState({ selectedClient });
    },
    afterLogout: () => ({ setState }) => {
      setState({ selectedClient: null, clientView: false });
    }
  },
  // optional, mostly used for easy debugging
  name: 'DashboardStore'
});

const useDashboardStore = createHook(DashboardStore);

export default useDashboardStore;
